module.exports = __webpack_public_path__ + "static/media/monthVip.0721ea9a.png";